import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import Dialog from "@reach/dialog"
import { AuthenticationDialog } from "./AuthenticationDialog"
import { UserContext } from "../HomeApp"
import {
  closeAuthDialog,
  selectShowAuthDialog,
  selectAuthDialogModalState,
  selectAuthDialogExplanation,
  selectAuthDialogBandId,
  selectAuthDialogDefaultBandType,
} from "../../stores/navigationSlice"

/**
 * Renders the AuthenticationDialog when Redux navigation state says to show it.
 * Mount this once at the app root; components open the dialog via openAuthDialog().
 */
export const AuthDialogContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { user } = useContext(UserContext)
  const showAuthDialog = useSelector(selectShowAuthDialog)
  const modalState = useSelector(selectAuthDialogModalState)
  const explanation = useSelector(selectAuthDialogExplanation)
  const bandId = useSelector(selectAuthDialogBandId)
  const defaultBandType = useSelector(selectAuthDialogDefaultBandType)

  if (!showAuthDialog) return null

  const close = () => dispatch(closeAuthDialog())

  if (user) {
    return (
      <Dialog
        isOpen={true}
        onDismiss={close}
        aria-label="bandNada community member"
      >
        <div className="AuthenticationDialog__content">
          <div className="AuthenticationDialog__header">
            <span />
            <button
              className="AuthenticationDialog__close focus:outline-none"
              onClick={close}
              type="button"
              aria-label="Close"
            >
              <span className="focus:outline-none text-lg" aria-hidden>
                ×
              </span>
            </button>
          </div>
          <div className="py-6 text-center">
            <p className="font-bold text-lg mb-2">
              Thank you for being part of the bandNada Community
            </p>
            <p className="text-gray-600 text-sm">
              You own {user.current_share_total ?? 0} shares of bandNada
            </p>
          </div>
        </div>
      </Dialog>
    )
  }

  return (
    <AuthenticationDialog
      initShowDialog={true}
      initModalState={modalState}
      explanation={explanation}
      bandId={bandId}
      defaultBandType={defaultBandType}
      closeDialog={close}
    />
  )
}
